<template>
    <div>
        <title-screen title ="1"></title-screen>
        <div id="station-tax-cl" class="result-search">
            <!-- Form search-->
            <search-form @dataTax="handleDataTax" @clearCurrentRow="clearCurrentRow" @closeTax="handleCloseTax"></search-form>
            <!--End form search-->
            <!--Icon close-->
            <p class="mt2" id="result-search-totalItem">
                <template v-if="isSearch">
                  <span v-if="totalItem === 0">該当の路線名、駅名は登録されていません</span>
                  <span v-else>{{ totalItem }}件のデータが見つかりました。表示したい駅をクリックしてください。</span>
                </template>
            </p>
            <a class="button-hide-show" id="button-hide-table-result" v-show="isHiddeTable" @click="handleHideTable">
                -
            </a>
            <a class="button-hide-show" id="button-show-table-result" v-show="isShowTable" @click="handleShowTable">
                +
            </a>
            <!--End icon close-->
            <!-- Table data master-->
            <div class="table-responsive  table-station-tax" >
                <table class="table m-0 table-result" v-show="isStationTax">
                    <thead>
                    <tr>
                        <th>路線名</th>
                        <th>駅名</th>
                        <th>乗降者数</th>
                        <th>算出住所</th>
                        <th>路線価</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-if="!tableStationTax.length  || tableStationTax.length === 0">
                        <tr class="empty-data">
                            <td colspan="5" class="el-table__empty-text">検索を行ってください。</td>
                        </tr>
                    </template>
                    <tr v-for="(data, index) in tableStationTax" :key="index" :value="index"  @mouseover="hover = false" @mouseleave="hover = false"
                         :class="getTableRowClassName(data, index)" @click="rowClick(data)">
                        <td>
                            {{ data.routeName }}
                        </td>
                        <td>
                            {{ data.stationName }}
                        </td>
                        <td>
                            {{ data.passengerNumber }}
                        </td>
                        <td>
                            {{ data.address }}
                        </td>
                        <td class="text-right">
                            {{ data.routePrice }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!-- End Table data master-->
            <!--Page-->
            <div class="block block-pagination" style="width: 100%; float: left">
                <el-pagination
                        type="local"
                        v-show="isStationTaxPaging"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-sizes="[5, 10, 20, 50, 100]"
                        :pager-count="pageCount"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next"
                        :data="tableStationTax"
                        :total="totalItem">
                </el-pagination>
            </div>
        </div>
        <!-- Show dialog upload-->
        <div class="detail" id="detail"
             v-show="isHarajuku">
            <template>
                <div class="header-dialog-eki">
                    <ul>
                        <li class="icon-subway">
                            <font-awesome-icon :icon="['fas', 'subway']" class="icon alt icon-eki"/> {{ titleEki }}
                            <el-link :underline="false" @click="handleCloseShowTable" class="el-link-close"><i class="el-icon-close"></i></el-link>
                        </li>
                        <li>
                            <ul>
                                <li class="number-of-pass" :class="isMobile ? 'number-of-pass-mobile': ''">
                                    <p v-if="!isMobile">乗降者数 {{isPassengers}}</p>
                                    <p v-if="isMobile">●乗降者数：{{isPassengers}}</p>
                                </li>
                                <li class="calculated-address" :class="isMobile ? 'calculated-address-mobile': ''">
                                    <p>●算出住所地：{{isCalculatedAddress}}</p>
                                </li>
                                <li class="route-price" :class="isMobile ? 'route-price-mobile': ''">
                                    <p>●路線価：{{isRoutePrice}}千円(前年比 {{isPrevPriceCompareRate}}%) </p>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <!-- Table data child-->
                <div class="table-responsive  table-station-tax table-station-tax-child" >
                    <table class="table m-0 table-result" v-show="isStationTax">
                        <thead>
                            <tr>
                                <th>種別</th>
                                <th>{{wareki(fiscalYear)}}度相続税額</th>
                                <th>納税による貯蓄減少率</th>
                                <th>売却による土地の減少率</th>
                                <th>路線価区分</th>
                                <th>節税のための限界税率</th>
                                <th>関連コンテンツ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="!tableStationTaxChild.length  || tableStationTaxChild.length === 0">
                                <tr class="empty-data">
                                    <td colspan="7" class="el-table__empty-text">データなし。</td>
                                </tr>
                            </template>
                            <template v-for="(data, index) in tableStationTaxChild">
                                <tr :key="index" :value="index">
                                    <td>{{data.type}}</td>
                                    <td>{{data.inheritanceTax}}</td>
                                    <td>{{data.decreaseRate}}</td>
                                    <td>{{data.landDecreaseRate}}</td>
                                    <td>
                                        <span
                                            v-bind:class="getDecreaseRateClass(data.routePriceDivision)"
                                            disable-transitions>
                                            {{data.routePriceDivision}}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            v-bind:class="getDecreaseRateClass(data.routePriceDivision)"
                                            disable-transitions>
                                            {{data.limitTaxRate}}
                                        </span>
                                    </td>
                                    <td>
                                        <el-link :href="data.path" target="_blank" class="el-link-eki">
                                            <span v-bind:class="getGtmClass(data.type)">詳細</span>
                                        </el-link>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <p class="mt1">
                  <router-link to="/calculation/tax" target="_blank">
                      <i class="el-icon-caret-right gtm_rosenka_kanntan_r" style="font-size: 20px; text-decoration: underline !important; color: #006ce5 !important;">「相続税かんたん計算」はこちら (詳細の資産状況が分かる場合は、こちらから相続税額をご確認いだけます。)</i>
                  </router-link>
                </p>
                <div class="btn-contact">
                  <el-button class="el-button-big gtm_rosenka_soudan_r" @click="redirectContact"><span class="gtm_rosenka_soudan_r">相続税について</span><br/><span class="gtm_rosenka_soudan_r">より詳細に相談したい方はこちら</span></el-button>
                </div>
                <!-- End Table data child-->
                <!--Page link status-->
                <ol class="mt1 link blog-station">
                    <li class="view-tax-01">
                        <img height="18px" src="@/images/sim_card.png" alt="10秒でわかる相続税の見方">
                        <a>
                            10秒でわかる相続税の見方
                        </a>
                    </li>
                    <li class="view-tax-02">
                        <img height="18px" src="@/images/sim_card.png" alt="相続税の影響と、その路線価・限界税率表">
                        <a>
                            相続税の影響と、その路線価・限界税率表
                        </a>
                    </li>
                    <li class="view-tax-03">
                        <img height="18px" src="@/images/sim_card.png" alt="モデルパターンについて">
                        <a>
                            モデルパターンについて
                        </a>
                    </li>
                </ol>
                <!--End page link status-->
                <!--Inheritance-->
                <station-inheritance></station-inheritance>
                <!--End Inheritance-->
            </template>
        </div>
        <!-- End show dialog upload-->
    </div>
</template>
<script>
import SearchStationTax from '@/components/form/SearchStationTax.vue'
import StationInheritanceTax from './StationInheritanceTax.vue'
import stationTax from '@/api/stationtax/station-tax-cl.js'
import TitleScreen from '@/components/common/TitleScreen'
import wareki from '../../../../common/wareki'

import { isMobile } from 'mobile-device-detect'
export default {
  components: {
    'search-form': SearchStationTax,
    'station-inheritance': StationInheritanceTax,
    'title-screen': TitleScreen
  },
  data () {
    return {
      titleEki: '',
      isStationTaxPaging: false,
      tableStationTax: [],
      dialogHarajuku: [],
      isHarajuku: false,
      isStationTax: true,
      tableStationTaxChild: [],
      isStationTaxChild: false,
      currentPage: 1,
      totalItem: 0,
      pageSize: 5,
      isHidden: false,
      currentRow: null,
      isUnderline: false,
      isHiddeTable: true,
      isShowTable: false,
      isDataTax: [],
      isPassengers: '',
      isCalculatedAddress: '',
      isRoutePrice: '',
      isArrayRefer: [],
      hover: false,
      isPrevPriceCompareRate: '',
      rowId: [
        {
          id: ''
        }
      ],
      isSearch: false,
      isClickBtnSearch: false,
      isRowClick: false,
      pageCount: isMobile ? 5 : 7,
      fiscalYear: null,
      isMobile: isMobile
    }
  },
  methods: {
    getTableRowClassName (data, index) {
        if (this.rowId === data.id) {
            return 'current-row'
        }
        if ((index % 2) === 0) {
            return 'child-table-row'
        }
        return ''
    },
    tableRowClassName ({ row, rowIndex }) {
    // function set color of row
      if ((rowIndex % 2) === 0) {
        return 'child-table-row'
      }
      return ''
    },
    handleDataTax (val) {
      this.isDataTax = val || []
      this.isSearch = !!val
      if (this.isDataTax <= 0) {
        this.handleCloseShowTable()
        this.tableStationTaxChild = []
        this.isStationTaxPaging = false
      }
      // handle if current page is out of data size
      if (this.currentPage !== 1) {
        if (this.isDataTax.length <= ((this.currentPage - 1) * this.pageSize)) {
          this.currentPage = 1
        }
      }
      this.showDataPagination(this.currentPage, this.pageSize)
    },
      clearCurrentRow () {
        this.rowId = ''
        this.isHarajuku = false
      },
    handleHideTable () {
      this.isStationTax = false
      this.isHiddeTable = false
      this.isShowTable = true
      this.isStationTaxPaging = false
    },
    handleShowTable () {
      this.isStationTax = true
      this.isHiddeTable = true
      this.isShowTable = false
      this.isStationTaxPaging = true
    },
    rowClickCurrent (val) {
      this.currentRow = val
      if (val != null && val.id !== undefined) {
        this.isHarajuku = true
      }
    },
    handleCloseShowTable () {
      this.isHarajuku = false
      this.showDataPagination(this.currentPage, this.pageSize)
    },
    rowClick (val) {
      this.rowId = val.id
      this.isStationTaxChild = true
      if (val != null && val.id !== undefined) {
        this.isHarajuku = true
      }
      stationTax.finItemById(this.rowId).then(response => {
        this.isStationTaxChild = true
        let _this = this
        _this.tableStationTaxChild = []
        _this.titleEki = ''
        response.forEach(function (item, index) {
            _this.fiscalYear = item.fiscalYear
          _this.isCalculatedAddress = item.address
          _this.isRoutePrice = item.routePrice.toLocaleString('en-US')
          _this.isPrevPriceCompareRate = (item.prevPriceCompareRate > 0 ? '+' : '') + Number.parseFloat(item.prevPriceCompareRate).toFixed(1)
          if (item.passengerNumber === '不明') {
            _this.isPassengers = item.passengerNumber
            _this.isPassengers = '不明'
          } else {
            _this.isPassengers = item.passengerNumber + '千人'
          }
          _this.titleEki = item.stationName
          _this.tableStationTaxChild.push(
            { 'type': '一軒家', 'inheritanceTax': item.inheritanceTax1.toLocaleString('en-US') + '千円', 'decreaseRate': Number.parseFloat(item.decreaseRate1).toFixed(1) + '%', 'landDecreaseRate': Number.parseFloat(item.landDecreaseRate1).toFixed(1) + '%', 'routePriceDivision': item.routePriceDivision1, 'limitTaxRate': item.limitTaxRate1 + '%', 'path': '/category?previousPage=stationTax' },
            { 'type': '地主', 'inheritanceTax': item.inheritanceTax2.toLocaleString('en-US') + '千円', 'decreaseRate': Number.parseFloat(item.decreaseRate2).toFixed(1) + '%', 'landDecreaseRate': Number.parseFloat(item.landDecreaseRate2).toFixed(1) + '%', 'routePriceDivision': item.routePriceDivision2, 'limitTaxRate': item.limitTaxRate2 + '%', 'path': 'https://legacy.ne.jp/forCustomer/landowner/index.html' },
            { 'type': '大地主', 'inheritanceTax': item.inheritanceTax3.toLocaleString('en-US') + '千円', 'decreaseRate': Number.parseFloat(item.decreaseRate3).toFixed(1) + '%', 'landDecreaseRate': Number.parseFloat(item.landDecreaseRate3).toFixed(1) + '%', 'routePriceDivision': item.routePriceDivision3, 'limitTaxRate': item.limitTaxRate3 + '%', 'path': 'https://legacy.ne.jp/forCustomer/landowner/index.html' }
          )
        })
        if (_this.tableStationTaxChild.length > 0) {
          this.isStationTaxChild = true
        } else {
          this.isStationTaxChild = false
        }
      })
      this.isRowClick = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.showDataPagination(this.currentPage, this.pageSize)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.showDataPagination(this.currentPage, this.pageSize)
    },
    showDataPagination (currentPage, rowInTable) {
      let _this = this
      _this.tableStationTax = []
      this.isDataTax.forEach(function (item, index) {
        _this.totalItem = index + 1
        let _startRow = (currentPage - 1) * rowInTable
        let _startEnd = currentPage * rowInTable
        if (_startRow <= index && index < _startEnd) {
          let passengerNumber = ''
          if (item.passengerNumber === '不明') {
            passengerNumber = item.passengerNumber
          } else {
            passengerNumber = item.passengerNumber + '千人'
          }
          _this.tableStationTax.push({ 'id': item.id, 'stationName': item.stationName, 'routeName': item.routeName, 'passengerNumber': passengerNumber, 'address': item.address, 'routePrice': item.routePrice.toLocaleString('en-US') + '千円' })
        }
      })
      if (_this.tableStationTax.length > 0) {
        this.isStationTaxPaging = true
      } else {
        this.totalItem = 0
      }
      this.isClickBtnSearch = true
    },
    handleCloseTax () {
      this.isStationTaxChild = false
      this.tableStationTaxChild = []
    },
    getGtmClass (type) {
      if (type === '一軒家') {
        return 'gtm_rosenka_kodate'
      } else if (type === '地主') {
        return 'gtm_rosenka_jinusi'
      } else if (type === '大地主') {
        return 'gtm_rosenka_oojinusi'
      } else {
        return ''
      }
    },
    redirectContact () {
      let routeData = this.$router.resolve({ name: 'contact' })
      window.open(routeData.href, '_blank')
    },
      wareki,
    getDecreaseRateClass (routePriceDivision) {
      const hankakuStr = routePriceDivision.replace(/[Ａ-Ｚ]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
      })
      let classStr
      switch (hankakuStr) {
        case 'A':
          classStr = 'decreaseRate decreaseRateA'
          break
        case 'B':
          classStr = 'decreaseRate decreaseRateB'
          break
        case 'C':
          classStr = 'decreaseRate decreaseRateC'
          break
        case 'D':
          classStr = 'decreaseRate decreaseRateD'
          break
        default:
          classStr = 'decreaseRate decreaseRateE'
      }

      return classStr
    }
  },
  created () {
    this.isHidden = false
    window.scroll(0, 0)
  },
  mounted () {
    let $ = this._$
    $('.view-tax-01').click(function () {
      $('html, body').delay(10).animate({
        scrollTop: $('#tax').offset().top - 150
      }, 1000)
    })
    $('.view-tax-02').click(function () {
      // $(document).scrollTo('#limit_tariff')
      $('html, body').delay(10).animate({
        scrollTop: $('#limit_tariff').offset().top - 150
      }, 1000)
    })
    $('.view-tax-03').click(function () {
      $('html, body').delay(10).animate({
        scrollTop: $('#model_patterns').offset().top - 150
      }, 1000)
    })
    // $(window).resize(function () {
    //   if ($(window).width() < 600) {
    //     $('.el-pagination .el-pager').addClass('w20')
    //   } else {
    //     $('.el-pagination .el-pager').removeClass('w20')
    //   }
    // })
  },
   updated () {
        if (this.isClickBtnSearch) {
            let el = document.getElementById('result-search-totalItem')
            el.scrollIntoView(true)
            this.isClickBtnSearch = false
        }

       if (this.isRowClick) {
           let el = document.getElementById('detail')
           el.scrollIntoView(true)
           this.isRowClick = false
       }
    }
}
</script>
<style>
    @import "PFF-B-01.css";
    @import "../../../../assets/css/custom.css";
</style>
<style scoped>
    table thead {
        color: #909399;
        font-weight: 500;
    }
    table tr {
         background-color: #fffafa !important;
     }
    table th {
        text-align: center !important;
        font-size: 16px !important;
        /*background-color: #f7f0df !important;*/
        font-weight: bold !important;
        /*color: #321007 !important;*/
        color: #000000;
        margin-bottom: 20px;
    }
    table tbody td:first-child {
        color: #ff9900;
        font-weight: bold;
    }
    table td, table th {
        padding: 1em;
        min-width: 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        text-align: center;
    }
    table {
        width: 100%;
        margin: 1em auto;
        /*border: 2px solid #d6d6d6;*/
        /*border-collapse: separate !important;*/
        /*-webkit-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);*/
        /*-moz-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1)*/
        /*box-shadow: 2px 9px 18px -3p;x rgba(113,85,85,1);*/
    }
    _:-ms-lang(x)::-ms-backdrop, table {
        border-collapse: separate;
    }
    table tr:first-child th:first-child {
        border-top-left-radius: 10px;
    }
    table tr:first-child th:last-child {
        border-top-right-radius: 10px;
    }
    table tr:last-child td:first-child {
        border-bottom-left-radius: 10px;
    }

    table tr:last-child td:last-child {
        border-bottom-right-radius: 10px;
    }
    /*.table td {*/
    /*    border: 1px solid #d6d6d6;*/
    /*    text-align: center;*/
    /*    padding: 1em;*/
    /*    !*background: #e6f6fe;*!*/
    /*    font-size: 14px;*/
    /*}*/
    /*.table .bg-blue td {*/
    /*    background: #8edbff;*/
    /*}*/
    /*.table .bg-lightblue td {*/
    /*    background: #e6f6fe;*/
    /*}*/
    /*.table th {*/
    /*    border: 1px solid #d6d6d6;*/
    /*    text-align: center;*/
    /*    background-color: #f7f0df;*/
    /*    padding: 1em;*/
    /*    font-size: 16px;*/
    /*    font-weight: bold;*/
    /*    color: #321007;*/
    /*}*/
    table th,
    table td {
        background-color: #fffafa !important;
        padding: 1em 10px 1em 1em;
        border-right: 1px solid #bbb;
    }
    table th,
    table tr:not(:last-child) td {
        border-bottom: 1px solid #bbb;
    }
    table th:last-child,
    table td:last-child{
        border-right: none;
    }
    table thead th {
        border-bottom: 5px solid #ff9900;
    }

    tbody th {
        color: #ff9901;
    }
    tbody td.text-right {
        text-align: right !important;
    }
    .table-responsive {
        border-radius: 10px;
    }
    .table th {
        min-width: 110px !important;
    }
    .table th>.cell {
        vertical-align: middle;
        padding-left: 10px;
        padding-right: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-all;
        line-height: 23px;
    }
    table tr.empty-data td {
        padding: 0 !important;
    }
    .table-station-tax-child  table td span {
        vertical-align: middle;
    }
    .table-station-tax {
        border-bottom: none !important;
        border-right: none !important;
    }
    @media screen and (max-width: 580px) {
      .header-dialog-eki ul li ul li {
        overflow: visible !important;
      }
    }
    .table-station-tax th {
        background-color: #fffaf0 !important;
    }
    .table-station-tax-child table th:nth-child(3) {
      width: 130px !important;
    }
    .table-station-tax-child table th:nth-child(4) {
      width: 130px !important;
    }
    .table-station-tax-child table th:nth-child(6) {
      width: 130px !important;
    }
    .table-station-tax-child table td .decreaseRate {
      display: inline-block !important;
      padding: inherit !important;
    }
    @media screen and (max-width:767px) {
        .header-dialog-eki ul li.number-of-pass-mobile {
            width: 100% !important;
            text-align: left !important;
        }
        .header-dialog-eki ul li.calculated-address-mobile {
            width: 100% !important;
            text-align: left !important;
        }
        .header-dialog-eki ul li.route-price-mobile {
            width: 100% !important;
            text-align: left !important;
        }
    }
    .btn-contact {
      margin-top: 20px;
      text-align: center;
    }
    .btn-contact button {
      line-height: normal;
    }
</style>
